import { matchPath, useLocation } from 'react-router-dom';

export interface RouteInfo {
    clientId: number | undefined;
    locationId: number | undefined;
    cageId: number | undefined;
    pagePath: string;
}

function parseIntParam(value: string | undefined): number | undefined {
    return value !== undefined ? Number.parseInt(value, 10) : undefined;
}

/**
 * Extracts client, location, and cage IDs from the current URL,
 * along with the trailing path segment after the most specific match.
 */
export function useRouteInfo(): RouteInfo {
    const { pathname } = useLocation();

    const clientMatch = matchPath({ path: '/c/:clientId', end: false }, pathname);
    const locationMatch = matchPath(
        { path: '/c/:clientId/location/:locationId', end: false },
        pathname
    );
    const cageMatch = matchPath(
        { path: '/c/:clientId/location/:locationId/pen/:cageId', end: false },
        pathname
    );

    // Compute the trailing URL part after the most specific match
    let pagePath = '';
    if (cageMatch) {
        pagePath = pathname.replace(cageMatch.pathname, '');
    } else if (locationMatch) {
        pagePath = pathname.replace(locationMatch.pathname, '');
    } else if (clientMatch) {
        pagePath = pathname.replace(clientMatch.pathname, '');
    } else if (pathname.startsWith('/internal')) {
        pagePath = pathname.replace('/internal', '');
    }

    return {
        clientId: parseIntParam(clientMatch?.params.clientId),
        locationId: parseIntParam(locationMatch?.params.locationId),
        cageId: parseIntParam(cageMatch?.params.cageId),
        pagePath,
    };
}
